import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { SelfServiceService } from '../services/selfservice.service';


@Injectable({
  providedIn: 'root',
})
export class SelfServicesGuard implements CanActivate {
  loggedInStatus: boolean = false;

  constructor(private selfService: SelfServiceService,
    private router: Router) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    const token = getCookie('myesse_access_token');

    if (this.loggedInStatus) {
      return true;
    }

    const usedIdp = getCookie('active_idp');
    if (usedIdp === 'ias-white-oidc' || usedIdp === 'ias-blue-oidc') {
      localStorage.setItem('oidc-login', usedIdp);
    } else {
      return false;
    }

    this.loggedInStatus = await this.selfService.validateToken(token!);

    if (this.loggedInStatus) {
      const requestId = next.queryParams['request_id'] ?? null;
      if (requestId) {
        this.router.navigate(['/selfservice', next.queryParams['type'], requestId]);
      } else {
        this.router.navigate(['/selfservice', next.queryParams['type']]);
      }
    } else {
      this.router.navigate(['/auth/login']);
    }

    return this.loggedInStatus;
  }
}
